import React, { useContext, useMemo } from "react";
import { Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
//import { AppContext } from "../../../store/AppContext";
import { SXModalBase } from "../SXModal";

interface PopUpProps {
  onClose: (ok: boolean) => void;
  question: string;
  show: boolean;
}

export const PopUpModal = (props: PopUpProps) => {
  //   const context = useContext(AppContext);
  const { t, i18n } = useTranslation();
  // const localisation = useContext(LocalisationContext);

  const footer = (
    <>
      <Button
        className="modal-btn"
        onClick={() => {
          props.onClose(true);
        }}
      >
        {t("yes_.label")}
      </Button>

      <Button
        className="modal-btn"
        onClick={() => {
          props.onClose(false);
        }}
      >
        {t("no_.label")}
      </Button>
    </>
  );

  const body = (
    <i>
      {/** not sure how this will work with i18n. Used to be getLabel */}
      {t(`${props.question}.label`)}
    </i>
  );

  return (
    <>
      <SXModalBase show={props.show} header={t("warning_.label")} size="sm" body={body} footer={footer} />
    </>
  );
};
